import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <main>
        <HeroSection />
        <ContactSection />
        <MediaSection />
        <FaqSection />
        <AppSection />
        <AboutSection />
        <CarouselSection />
        <CommentsSection />
        <IndexSection />
        <RankingSection />
        <UpdatesSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <FooterSection />
    </div>
  );
}